
const elementoScroll = document.getElementById('final-mosaico');
const filtroMosaicoScroll = document.querySelector('.filtros-mosaico');
let currentUrl = window.location.href;
let finalFixedFilter = false;

var contadorPaginacion = 2;

const options = {
    root: null,
    rootMargin: '20% 0px 0px 0px',
    threshold: 0
};


let validacion = paginateCollection > 10 ? 10 : paginateCollection;

const callback = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.target.id === 'final-mosaico' && entry.isIntersecting) {
            if (contadorPaginas <= paginateCollection){
                    RENDERIZAR_SECTION_DESPUES_PETICION_RED()
                    LoadMore(contadorPaginas)
                    contadorPaginas++;
                    document.querySelector(".paginacion-final").classList.remove("d-none");
                    if (finalFixedFilter) {
                        filtroMosaicoScroll.classList.add("intersection")
                    }
            } else {
                filtroMosaicoScroll.classList.add("intersection")
                document.querySelector(".paginacion-final").classList.add("d-none");
                finalFixedFilter = true;
            }
        }
    });
};

// const observer = new IntersectionObserver(callback, options);
// observer.observe(elementoScroll);


//funcion para parsear los elementos html
// Función para hacer la petición de red y procesar el HTML
async function RENDERIZAR_SECTION_DESPUES_PETICION_RED(urlData) {
    let url = urlData ? urlData+'&sections=product-list' : currentUrl+'&sections=product-list&page='+contadorPaginas;
    let filter = urlData ? true : false;
    try {
        const response = await fetch(sanitizeURL(url));
        
        if (!response.ok) {
            throw new Error(`Error en la petición: ${response.status}`);
        }

        const text = await response.json();

        const parser = new DOMParser();
    
        const doc = parser.parseFromString(text['product-list'], 'text/html');

        const container = doc.querySelector('#shopify-section-product-list'); // Cambia 'div' por el selector adecuado si es necesario
        if (!container) {
            throw new Error('No se encontró el contenedor HTML especificado');
        }

        const innerContent = container.innerHTML;

        renderHTML(innerContent, filter);

    } catch (error) {
        console.error('Ocurrió un error:', error);
    }
}

// Función para renderizar el HTML
function renderHTML(htmlContent, filter) {
    const container = document.querySelector('.product-list'); 
    // container.innerHTML += htmlContent;
        container.insertAdjacentHTML('beforeend', htmlContent);
        getAllProductsSku();
        
}

//Funciona de filtro de mosaico
document.addEventListener('DOMContentLoaded', (event) => {
    // Selecciona todos los elementos con la clase 'subfilter'
    const subfilters = document.querySelectorAll('.subfilter');

    // Añade un event listener a cada elemento
    subfilters.forEach(subfilter => {
        subfilter.addEventListener('click', (event) => {
            // Evita el comportamiento predeterminado
            // event.preventDefault();

            // Obtén el valor del atributo 'data-link-filter'
            const filterValue = event.target.getAttribute('data-filter-link');

            RENDERIZAR_SECTION_DESPUES_PETICION_RED(filterValue)
        });
    });
});


// Mostrar o ocultar elemento de cargar más 
function LoadMore(numeroPagina){
    if (numeroPagina <= paginateCollection ) {
        document.querySelector(".paginacion-final").classList.remove("d-none");
    } else {
        document.querySelector(".paginacion-final").classList.add("d-none");
    }
}



// addevenlisteners
window.addEventListener("click",(e) =>{
    if (e.target.classList.contains("load-more-products")) {
        RENDERIZAR_SECTION_DESPUES_PETICION_RED()
        contadorPaginas++;
    }

    if(e.target.classList.contains("filtros-movil") || e.target.classList.contains("icon-close") ) {
        enableBackdrop()
    }
})


function sanitizeURL(url) {
    // Buscar el índice del primer '/', que sigue al protocolo
    const baseEndIndex = url.indexOf('/', 8); // 8 para saltar 'https://'
    
    // Buscar el primer '&' después del dominio/base de la URL
    const firstAmpersandIndex = url.indexOf('&', baseEndIndex);

    if (firstAmpersandIndex !== -1) {
        // Reemplazar '&' por '?'
        url = url.substring(0, firstAmpersandIndex) + '?' + url.substring(firstAmpersandIndex + 1);
    }

    // Asegurarse de que solo se mantenga el primer '?'
    const firstQuestionMarkIndex = url.indexOf('?');
    if (firstQuestionMarkIndex !== -1) {
        const remainingURL = url.substring(firstQuestionMarkIndex + 1);
        const sanitizedRemainingURL = remainingURL.replace(/\?/g, '&');
        url = url.substring(0, firstQuestionMarkIndex + 1) + sanitizedRemainingURL;
    }

    return url;
}


document.querySelectorAll('.order-item').forEach(function(element) {
    element.addEventListener('click', function(e) {
        e.preventDefault()
        let stringOrdenamiento = e.target.getAttribute("data-order-item")
        const url = new URL(window.location);
        url.searchParams.set('sort_by', stringOrdenamiento);
        window.location.href = url.toString();
    });
});


//funcion para creas las intercepciones
function createClientYObserver(targetId, referenceId) {
    const targetElement = document.querySelector(targetId);
    const referenceElement = document.querySelector(referenceId);

    if (!targetElement || !referenceElement) {
        console.error('Elementos no encontrados, verifique los IDs proporcionados.');
        return;
    }

    const checkClientYPosition = () => {
        const rect = referenceElement.getBoundingClientRect();
        if (rect.y < 0) {
            targetElement.classList.remove('d-none');
            targetElement.classList.add('d-flex');
        } else {
            targetElement.classList.remove('d-flex');
            targetElement.classList.add('d-none');
        }
    };
    checkClientYPosition()
  
}

let isFixedMosaicDesktop  = false; 
function checkFiltersFixed(targetId) {
    const targetElement = document.querySelector(targetId);
    const destElement = document.querySelector(".filtros-mosaico");

    const mediaQuery = window.matchMedia('(min-width: 768px)');

    const checkClientYPosition = () => {
        if (!mediaQuery.matches) {
            destElement.classList.remove('fijo');
            isFixedMosaicDesktop = false;
            return; // Si la pantalla es menor a 768px, salir de la función
        }

        const rect = targetElement.getBoundingClientRect();
        if (rect.y < 0 && !isFixedMosaicDesktop) {
            destElement.classList.add('fijo');
            isFixedMosaicDesktop = true; // Marcar como fijado
        } else if (rect.y >= 0 && isFixedMosaicDesktop) {
            destElement.classList.remove('fijo');
            isFixedMosaicDesktop = false; // Marcar como no fijado
        }
    };

    mediaQuery.addEventListener('change', checkClientYPosition); // Rechequear si cambia el tamaño de la pantalla
    checkClientYPosition(); // Ejecutar la función inmediatamente para el estado inicial
}

let isFixedFiltersMovil  = false; 

function checkFiltersFixedMovil(targetId) {
    const targetElement = document.querySelector(targetId);
    const destElement = document.querySelector(".container-filter-order");
    const headerCoords = document.querySelector("#shopify-section-d-header-homologado").clientHeight;

    const mediaQuery = window.matchMedia('(max-width:1025px)');

    const checkClientYPosition = () => {
        if (!mediaQuery.matches) {
            destElement.classList.remove('fijo');
            destElement.style.top = ''; // Restablecer el valor de top
            isFixedFiltersMovil = false;
            return; // Si la pantalla es mayor a 768px, salir de la función
        }

        const rect = targetElement.getBoundingClientRect();
        if (rect.y < 0 && !isFixedFiltersMovil) {
            destElement.style.top = headerCoords + 'px';
            destElement.classList.add('fijo');
            isFixedFiltersMovil = true; // Marcar como fijado
        } else if (rect.y >= 0 && isFixedFiltersMovil) {
            destElement.classList.remove('fijo');
            destElement.style.top = ''; // Restablecer el valor de top
            isFixedFiltersMovil = false; // Marcar como no fijado
        }
    };

    mediaQuery.addEventListener('change', checkClientYPosition); 
    checkClientYPosition(); 
}


// Escuchar el evento de desplazamiento
window.addEventListener('scroll', () => {
    createClientYObserver('#top-render', '#product-render-main');
    // checkFiltersFixed('#coords-filtros');
    checkFiltersFixedMovil("#coord-filter-movil")
});


document.addEventListener('DOMContentLoaded', function() {
    // Selecciona todos los elementos con el atributo data-scrollTo
    var scrollElements = document.querySelectorAll('[data-scrollTo]');

    // Agrega un event listener a cada elemento
    scrollElements.forEach(function(element) {
        element.addEventListener('click', function() {
            // Obtiene el valor de data-scrollTo
            var scrollToValue = element.getAttribute('data-scrollTo');
            
            // Desplaza la página a la posición especificada
            window.scrollTo({
                top: parseInt(scrollToValue),
                behavior: 'smooth'
            });
        });
    });
});

function enableBackdrop() {
    document.querySelector(".backdrop").classList.toggle("d-none")
}

document.addEventListener("DOMContentLoaded", function() {
    // const filtroMosaico = document.getElementById('filtro-mosaico');
    // const finalMosaico = document.getElementById('final-mosaico');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            return
        } else {
                filtroMosaicoScroll.classList.add("absolute");
                filtroMosaicoScroll.classList.remove("intersection");
        }
      });
    }, {
      root: null, // Usa la ventana de visualización como raíz
      rootMargin: '0px',
      threshold: 0 // Umbral de intersección (0 significa tan pronto como cualquier parte sea visible)
    });

    // observer.observe(finalMosaico);
});

function ScrollTop() {
    window.scrollTo(
        {
            top: 160, 
            behavior: 'smooth'
        }
    )
}
